import { isDate } from './isDate';
import { isNullish } from './isNullish';

/**
 * Determines whether a given value is an object
 */
export function isObject(value: any): value is object {
  return (
    !isNullish(value) &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    !isDate(value)
  );
}
